import React, { useState } from 'react';
import {
  ScrollView, Text, TouchableOpacity, View,
} from 'react-native';
import TopMenuServices from '../components/TopMenuServices';
import {
  back_str,
  getSubCategoryId,
  Next_str,
  select_package_title,
  services_category,
  Transfer_amount,
} from '../utils/DictionaryManagementUtils';
import Panel_B13_FlowChangeOrder from '../panels/Panel_B13_FlowChangeOrder';
import { LocStr } from '../utils/Utils';
import Panel_V01_announcement from '../panels/Panel_V01_announcement';
import Panel_V02_promotion from '../panels/Panel_V02_promotion';
import Panel_V03_instructions from '../panels/Panel_V03_instructions';
import Panel_T01_launch_keyboard from '../panels/Panel_T01_launch_keyboard';
import Panel_T02_launch_auth from '../panels/Panel_T02_launch_auth';
import Panel_T03_launch_error_messages from '../panels/Panel_T03_launch_error_messages';
import Panel_T05_launch_empty_state from '../panels/Panel_T05_launch_empty_state';
import Panel_T06_iMsgExpandTexts from '../panels/Panel_T06_iMsgExpandTexts';
import Panel_A03_Menu from '../panels/Panel_A03_Menu';
import Panel_B03_SendMoneyTransferMethod from '../panels/Panel_B03_SendMoneyTransferMethod';
import Panel_B04_SendMoneyToCreditManually from '../panels/Panel_B04_SendMoneyToCreditManually';
import Panel_B02_SendMoneyRecipientList from '../panels/Panel_B02_SendMoneyRecipientList';
import Panel_B02_SendMoneySearchResults from '../panels/Panel_B02_SendMoneySearchResults';
import Panel_B05_SendMoneyToPhoneManually from '../panels/Panel_B05_SendMoneyToPhoneManually';
import Panel_B06_SendMoneyToAccountManually from '../panels/Panel_B06_SendMoneyToAccountManually';
import Panel_B07_SendMoneyToIBANManually from '../panels/Panel_B07_SendMoneyToIBANManually';
import Panel_B07_SendMoneyToCustomerIDManually from '../panels/Panel_B07_SendMoneyToCustomerIDManually';
import Panel_B07a_SendMoneyToCpfManually from '../panels/Panel_B07a_SendMoneyToCpfManually';
import Panel_B07b_SendMoneyToEmailManually from '../panels/Panel_B07b_SendMoneyToEmailManually';
import Panel_B07c_SendMoneyToEvpManually from '../panels/Panel_B07c_SendMoneyToEvpManually';
import Panel_B08_SendMoneyEnterAmount from '../panels/Panel_B08_SendMoneyEnterAmount';
import Panel_B08_SendMoneyPayingAccount from '../panels/Panel_B08_SendMoneyPayingAccount';
import Panel_B09_SendMoneyReference from '../panels/Panel_B09_SendMoneyReference';
import Panel_B10_SendMoneyConfirmation from '../panels/Panel_B10_SendMoneyConfirmation';
import Panel_B12_SendMoneySuccess from '../panels/Panel_B12_SendMoneySuccess';
import Panel_C02_AccountInfoBalance from '../panels/Panel_C02_AccountInfoBalance';
import Panel_C03_AccountInfoInOut from '../panels/Panel_C03_AccountInfoInOut';
import Panel_D01_PayBillsBillsList from '../panels/Panel_D01_PayBillsBillsList';
import Panel_D01_PayBillsPayingAccount from '../panels/Panel_D01_PayBillsPayingAccount';
import Panel_D02_PayBillsEnterCode from '../panels/Panel_D02_PayBillsEnterCode';
import Panel_D04_PayBillsConfirmation from '../panels/Panel_D04_PayBillsConfirmation';
import Panel_D06_PayBillsSuccess from '../panels/Panel_D06_PayBillsSuccess';
import Panel_F03_RequestPaymentTransferMethod from '../panels/Panel_F03_RequestPaymentTransferMethod';
import Panel_F04_RequestPaymentToCreditManually from '../panels/Panel_F04_RequestPaymentToCreditManually';
import Panel_F02_RequestPaymentRecipientList from '../panels/Panel_F02_RequestPaymentRecipientList';
import Panel_F02_RequestPaymentSearchResults from '../panels/Panel_F02_RequestPaymentSearchResults';
import Panel_F05_RequestPaymentToPhoneManually from '../panels/Panel_F05_RequestPaymentToPhoneManually';
import Panel_F06_RequestPaymentToAccountManually from '../panels/Panel_F06_RequestPaymentToAccountManually';
import Panel_F07_RequestPaymentToIBANManually from '../panels/Panel_F07_RequestPaymentToIBANManually';
import Panel_F07_RequestPaymentToCustomerIDManually from '../panels/Panel_F07_RequestPaymentToCustomerIDManually';
import Panel_F07a_RequestPaymentToCpfManually from '../panels/Panel_F07a_RequestPaymentToCpfManually';
import Panel_F07b_RequestPaymentToEmailManually from '../panels/Panel_F07b_RequestPaymentToEmailManually';
import Panel_F07c_RequestPaymentToEvpManually from '../panels/Panel_F07c_RequestPaymentToEvpManually';
import Panel_F08_RequestPaymentEnterAmount from '../panels/Panel_F08_RequestPaymentEnterAmount';
import Panel_F08_RequestPaymentPayingAccount from '../panels/Panel_F08_RequestPaymentPayingAccount';
import Panel_F09_RequestPaymentReference from '../panels/Panel_F09_RequestPaymentReference';
import Panel_F10_RequestPaymentConfirmation from '../panels/Panel_F10_RequestPaymentConfirmation';
import Panel_F12_RequestPaymentSuccess from '../panels/Panel_F12_RequestPaymentSuccess';
import Panel_G03_SplitPaymentTransferMethod from '../panels/Panel_G03_SplitPaymentTransferMethod';
import Panel_G04_SplitPaymentToCreditManually from '../panels/Panel_G04_SplitPaymentToCreditManually';
import Panel_G02_SplitPaymentRecipientList from '../panels/Panel_G02_SplitPaymentRecipientList';
import Panel_G02_SplitPaymentConfirmParticipant from '../panels/Panel_G02_SplitPaymentConfirmParticipant';
import Panel_G02_SplitPaymentSearchResults from '../panels/Panel_G02_SplitPaymentSearchResults';
import Panel_G05_SplitPaymentToPhoneManually from '../panels/Panel_G05_SplitPaymentToPhoneManually';
import Panel_G06_SplitPaymentToAccountManually from '../panels/Panel_G06_SplitPaymentToAccountManually';
import Panel_G07_SplitPaymentToIBANManually from '../panels/Panel_G07_SplitPaymentToIBANManually';
import Panel_G07_SplitPaymentToCustomerIDManually from '../panels/Panel_G07_SplitPaymentToCustomerIDManually';
import Panel_G07a_SplitPaymentToCpfManually from '../panels/Panel_G07a_SplitPaymentToCpfManually';
import Panel_G07b_SplitPaymentToEmailManually from '../panels/Panel_G07b_SplitPaymentToEmailManually';
import Panel_G07c_SplitPaymentToEvpManually from '../panels/Panel_G07c_SplitPaymentToEvpManually';
import Panel_G08_SplitPaymentEnterAmount from '../panels/Panel_G08_SplitPaymentEnterAmount';
import Panel_G08_SplitPaymentPayingAccount from '../panels/Panel_G08_SplitPaymentPayingAccount';
import Panel_G09_SplitPaymentReference from '../panels/Panel_G09_SplitPaymentReference';
import Panel_G10_SplitPaymentConfirmation from '../panels/Panel_G10_SplitPaymentConfirmation';
import Panel_G12_SplitPaymentSuccess from '../panels/Panel_G12_SplitPaymentSuccess';
import Panel_H08_TopUpSelectOperator from '../panels/Panel_H08_TopUpSelectOperator';
import Panel_H08_TopUpSelectPackage from '../panels/Panel_H08_TopUpSelectPackage';
import Panel_X01_themeColors from '../panels/Panel_X01_themeColors';
import Panel_X01_themeRadius from '../panels/Panel_X01_themeRadius';
import Panel_X02_themeFonts from '../panels/Panel_X02_themeFonts';
import Panel_Z01_send_form from '../panels/Panel_Z01_send_form';
import Panel_Z02_development_configurations from '../panels/Panel_Z02_development_configurations';
import Panel_Y01_keyboardLanguage from '../panels/Panel_Y01_keyboardLanguage';
import Panel_E01_Deliverables from '../panels/Panel_E01_Deliverables';
import Panel_Y02_keyboardPromotion from '../panels/Panel_Y02_keyboardPromotion';
import Panel_E02_UserTypes from '../panels/Panel_E02_UserTypes';
import Panel_I01_LinkOut from '../panels/Panel_I01_LinkOut';
import Panel_D01_PayBillsChooseMethod from '../panels/Panel_D01_PayBillsChooseMethod';
import Panel_J01_LoanUpdateAmount from '../panels/Panel_J01_LoanUpdateAmount';
import Panel_J02_LoanNumberInstallments from '../panels/Panel_J02_LoanNumberInstallments';
import Panel_J03_LoanSelectSource from '../panels/Panel_J03_LoanSelectSource';
import Panel_J04_LoanInstallmentOptions from '../panels/Panel_J04_LoanInstallmentOptions';
import Panel_J05_LoanConfirmation from '../panels/Panel_J05_LoanConfirmation';
import Panel_J06_LoanSuccess from '../panels/Panel_J06_LoanSuccess';

//= ========================================================================
const ControlPanelViewer = ({
  globJSON,
  selectedUser,
  loggedInUserItem,
  language,
  selectedScreen,
  ref_scroll_view,
  onConfigChanged,
  deviceType,
  startExportingAllFiles,
  myUpdateSelectedScreen,
  screenHeight,
}) => {
  const myStyles = {
    controlPanel: {
      width: 560,
      height: screenHeight - 60,
    },
    controlPanelPopup: {
      width: 560,
      height: screenHeight - 73,
    },
    controlPanelBottomBar: {
      height: 73,
      flexDirection: 'row',
      backgroundColor: '#f0f5f9',
    },
    btnBack: {
      height: 71,
      flex: 1,
      marginTop: 2,
      justifyContent: 'center',
      backgroundColor: '#fff',
    },
    btnNext: {
      height: 71,
      flex: 1,
      marginTop: 2,
      marginLeft: 2,
      justifyContent: 'center',
      backgroundColor: '#fff',
    },
    bottomLabel: {
      fontFamily: 'Rubik-Medium',
      fontSize: 18,
      color: '#001a2f',
      position: 'absolute',
      alignSelf: 'center',
    },
    bottomLabelGrey: {
      fontFamily: 'Rubik-Medium',
      fontSize: 18,
      color: '#a0aec0',
      position: 'absolute',
      alignSelf: 'center',
    },
    pagesStyle: {
      width: 560,
      height: screenHeight - 73,
      marginLeft: 0,
    },

  };
  const [popupChangeOrderScreen, setPopupChangeOrderScreen] = useState('');
  const simPlatform = deviceType.selectedPlatform;
  const isSendDisabled = selectedScreen === globJSON.screens.length - 1;
  const onSendMoneyOrderScreenReturning = (didChange, subCategoryId) => {
    if (didChange) {
      onConfigChanged();

      handlePressOnServicesTab(subCategoryId);
    }

    // setPopupChangeOrderScreen('');
  };

  const onScroll = (evt) => {
    const offX = evt.nativeEvent.contentOffset.x;
    if (offX % 560 === 0) {
      const idx = Math.floor(offX / 560);
      const wantedScreen = globJSON.screens.findIndex(
        (item) => item.screen_index === idx,
      );
      if (wantedScreen !== -1) {
        myUpdateSelectedScreen(wantedScreen);
      }
    }
  };

  //----------------------------------------------------------------------

  const handleStepPressed = (wantedIndex, screenCameFrom) => {
    let wantedScreen;

    if (
      screenCameFrom.sub_category !== undefined
            && screenCameFrom.screen_index !== undefined
    ) {
      wantedScreen = globJSON.screens.findIndex(
        (screen) => screen.category === screenCameFrom.category
                    && screen.sub_category === screenCameFrom.sub_category
                    && screen.duplication_number === screenCameFrom.duplication_number
                    && screen.step_index === wantedIndex,
      );
    } else {
      wantedScreen = globJSON.screens.findIndex(
        (item) => item.category === screenCameFrom.category,
      );
      wantedScreen += wantedIndex;
    }

    if (wantedScreen !== -1) {
      ref_scroll_view.current.scrollTo({
        x: 560 * wantedScreen,
        y: 0,
        animated: false,
      });
      myUpdateSelectedScreen(wantedScreen);
    }
  };

  //----------------------------------------------------------------------

  const handlePressOnServicesTab = (wantedTab) => {
    // if (popupChangeOrderScreen !== '') {
    //   setPopupChangeOrderScreen('');
    // }

    const wantedScreen = globJSON.screens.findIndex((item) => {
      const flowId = getSubCategoryId(item);
      return item.category === services_category && flowId === wantedTab;
    });
    if (wantedScreen !== -1) {
      ref_scroll_view.current.scrollTo({
        x: 560 * wantedScreen,
        y: 0,
        animated: false,
      });
      myUpdateSelectedScreen(wantedScreen);
    }
  };

  const calcSelectedServiceTab = () => {
    const { sub_category } = globJSON.screens[selectedScreen];
    const { duplication_number } = globJSON.screens[selectedScreen];
    return globJSON.configurations.services.screens_ordering
      .filter((serviceKey) => globJSON.configurations.services[serviceKey].selected)
      .findIndex((serviceKey) => globJSON.configurations.services[serviceKey].sub_category === sub_category
                && globJSON.configurations.services[serviceKey].duplication_number === duplication_number);
  };

  const onGotoEdit = () => {
    // setPopupChangeOrderScreen('send_money_change_order');
  };

  // ######################################################################
  // ###   C o n t r o l   P a n e l   n a v i g a t i o n
  // ######################################################################

  const onBackPressed = () => {
    // if (popupChangeOrderScreen !== '') {
    //   setPopupChangeOrderScreen('');
    //   return;
    // }

    if (selectedScreen > 0) {
      const prev = selectedScreen - 1;

      ref_scroll_view.current.scrollTo({
        x: 560 * globJSON.screens[prev].screen_index,
        y: 0,
        animated: true,
      });
      myUpdateSelectedScreen(prev);
    }
  };

  const onNextPressed = () => {
    if (selectedScreen < globJSON.screens.length - 1) {
      const next = selectedScreen + 1;

      ref_scroll_view.current.scrollTo({
        x: 560 * globJSON.screens[next].screen_index,
        y: 0,
        animated: true,
      });
      myUpdateSelectedScreen(next);
    }
  };

  const renderControlPanelAllViews = () => {
    let screenIndex = 0;
    return globJSON.screens.map((item, index) => {
      globJSON.screens[index].screen_index = screenIndex;
      screenIndex += 1;
      const key_screen = `${item.screen_name}_${index}`;
      return (
        <View style={myStyles.pagesStyle} key={key_screen}>
          {renderControlPanelSingleView(index)}
        </View>
      );
    });
  };
  const renderControlPanelSingleView = (index) => {
    switch (globJSON.screens[index].screen_name) {
      case 'onboarding_announcement':
        return (
          <Panel_V01_announcement
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );
      case 'onboarding_promotion':
        return (
          <Panel_V02_promotion
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );
      case 'onboarding_instructions':
        return (
          <Panel_V03_instructions
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            simPlatform={simPlatform}
          />
        );

      case 'launch_keyboard':
        return (
          <Panel_T01_launch_keyboard
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            simPlatform={simPlatform}
            language={language}
          />
        );
      case 'launch_auth':
        return (
          <Panel_T02_launch_auth
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );
      case 'launch_error_messages':
        return (
          <Panel_T03_launch_error_messages
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );
      case 'launch_empty_state':
        return (
          <Panel_T05_launch_empty_state
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );
      case 'imsg_expand_texts':
        return (
          <Panel_T06_iMsgExpandTexts
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );

      case 'deliverables':
        return (
          <Panel_E01_Deliverables
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            globJSON={globJSON}
            selectedScreen={index}
            language={language}
          />
        );

      case 'user_types':
        return (
          <Panel_E02_UserTypes
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            globJSON={globJSON}
            selectedScreen={index}
            language={language}
          />
        );

      case services_category:
        return (
          <Panel_A03_Menu
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );
      case 'send_money_transfer_method':
        return (
          <Panel_B03_SendMoneyTransferMethod
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'send_money_to_credit_card_manually':
        return (
          <Panel_B04_SendMoneyToCreditManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'send_money_recipients_list':
        return (
          <Panel_B02_SendMoneyRecipientList
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'send_money_search_results':
        return (
          <Panel_B02_SendMoneySearchResults
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'send_money_to_phone_manually':
        return (
          <Panel_B05_SendMoneyToPhoneManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'send_money_to_account_manually':
        return (
          <Panel_B06_SendMoneyToAccountManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'send_money_to_iban_manually':
        return (
          <Panel_B07_SendMoneyToIBANManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'send_money_to_customer_id_manually':
        return (
          <Panel_B07_SendMoneyToCustomerIDManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'send_money_to_cpf_cnpj_manually':
        return (
          <Panel_B07a_SendMoneyToCpfManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'send_money_to_email_manually':
        return (
          <Panel_B07b_SendMoneyToEmailManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'send_money_to_evp_manually':
        return (
          <Panel_B07c_SendMoneyToEvpManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'send_money_enter_amount':
        return (
          <Panel_B08_SendMoneyEnterAmount
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'send_money_change_paying_account':
        return (
          <Panel_B08_SendMoneyPayingAccount
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
            panelHeadline={Transfer_amount}
          />
        );
      case 'send_money_reference':
        return (
          <Panel_B09_SendMoneyReference
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'send_money_confirmation':
        return (
          <Panel_B10_SendMoneyConfirmation
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'send_money_success':
        return (
          <Panel_B12_SendMoneySuccess
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            simPlatform={simPlatform}
            language={language}
          />
        );
      case 'loan_amount':
        return (
          <Panel_J01_LoanUpdateAmount
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'loan_installments_number':
        return (
          <Panel_J02_LoanNumberInstallments
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'loan_source':
        return (
          <Panel_J03_LoanSelectSource
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'loan_installments_option':
        return (
          <Panel_J04_LoanInstallmentOptions
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'loan_confirmation':
        return (
          <Panel_J05_LoanConfirmation
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'loan_success':
        return (
          <Panel_J06_LoanSuccess
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'account_info_balance':
        return (
          <Panel_C02_AccountInfoBalance
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );
      case 'account_info_inout':
        return (
          <Panel_C03_AccountInfoInOut
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );

      case 'pay_bills_bills_list':
        return (
          <Panel_D01_PayBillsBillsList
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );
      case 'pay_bills_choose_method':
        return (
          <Panel_D01_PayBillsChooseMethod
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );
      case 'pay_bills_Change_paying_account':
        return (
          <Panel_D01_PayBillsPayingAccount
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );
      case 'pay_bills_enter_code':
        return (
          <Panel_D02_PayBillsEnterCode
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            simPlatform={simPlatform}
            language={language}
          />
        );
      case 'pay_bills_confirmation':
        return (
          <Panel_D04_PayBillsConfirmation
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );
      case 'pay_bills_success':
        return (
          <Panel_D06_PayBillsSuccess
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            simPlatform={simPlatform}
            language={language}
          />
        );
      case 'request_payment_transfer_method':
        return (
          <Panel_F03_RequestPaymentTransferMethod
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'request_payment_to_credit_card_manually':
        return (
          <Panel_F04_RequestPaymentToCreditManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'request_payment_recipients_list':
        return (
          <Panel_F02_RequestPaymentRecipientList
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'request_payment_search_results':
        return (
          <Panel_F02_RequestPaymentSearchResults
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'request_payment_to_phone_manually':
        return (
          <Panel_F05_RequestPaymentToPhoneManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'request_payment_to_account_manually':
        return (
          <Panel_F06_RequestPaymentToAccountManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'request_payment_to_iban_manually':
        return (
          <Panel_F07_RequestPaymentToIBANManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'request_payment_to_customer_id_manually':
        return (
          <Panel_F07_RequestPaymentToCustomerIDManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'request_payment_to_cpf_cnpj_manually':
        return (
          <Panel_F07a_RequestPaymentToCpfManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'request_payment_to_email_manually':
        return (
          <Panel_F07b_RequestPaymentToEmailManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'request_payment_to_evp_manually':
        return (
          <Panel_F07c_RequestPaymentToEvpManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'request_payment_enter_amount':
        return (
          <Panel_F08_RequestPaymentEnterAmount
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'request_payment_change_paying_account':
        return (
          <Panel_F08_RequestPaymentPayingAccount
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'request_payment_reference':
        return (
          <Panel_F09_RequestPaymentReference
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'request_payment_confirmation':
        return (
          <Panel_F10_RequestPaymentConfirmation
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'request_payment_success':
        return (
          <Panel_F12_RequestPaymentSuccess
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            simPlatform={simPlatform}
            language={language}
          />
        );

      case 'split_payment_transfer_method':
        return (
          <Panel_G03_SplitPaymentTransferMethod
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'split_payment_to_credit_card_manually':
        return (
          <Panel_G04_SplitPaymentToCreditManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'split_payment_recipients_list':
        return (
          <Panel_G02_SplitPaymentRecipientList
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'split_payment_confirm_participant':
        return (
          <Panel_G02_SplitPaymentConfirmParticipant
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'split_payment_search_results':
        return (
          <Panel_G02_SplitPaymentSearchResults
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'split_payment_to_phone_manually':
        return (
          <Panel_G05_SplitPaymentToPhoneManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'split_payment_to_account_manually':
        return (
          <Panel_G06_SplitPaymentToAccountManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'split_payment_to_iban_manually':
        return (
          <Panel_G07_SplitPaymentToIBANManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'split_payment_to_customer_id_manually':
        return (
          <Panel_G07_SplitPaymentToCustomerIDManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );

      case 'split_payment_to_cpf_cnpj_manually':
        return (
          <Panel_G07a_SplitPaymentToCpfManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'split_payment_to_email_manually':
        return (
          <Panel_G07b_SplitPaymentToEmailManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'split_payment_to_evp_manually':
        return (
          <Panel_G07c_SplitPaymentToEvpManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'split_payment_enter_amount':
        return (
          <Panel_G08_SplitPaymentEnterAmount
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'split_payment_change_paying_account':
        return (
          <Panel_G08_SplitPaymentPayingAccount
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'split_payment_reference':
        return (
          <Panel_G09_SplitPaymentReference
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'split_payment_confirmation':
        return (
          <Panel_G10_SplitPaymentConfirmation
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'split_payment_success':
        return (
          <Panel_G12_SplitPaymentSuccess
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            simPlatform={simPlatform}
            language={language}
          />
        );

      case 'top_up_transfer_method':
        return (
          <Panel_B03_SendMoneyTransferMethod
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'top_up_to_credit_card_manually':
        return (
          <Panel_B04_SendMoneyToCreditManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'top_up_recipients_list':
        return (
          <Panel_B02_SendMoneyRecipientList
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'top_up_search_results':
        return (
          <Panel_B02_SendMoneySearchResults
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'top_up_to_phone_manually':
        return (
          <Panel_B05_SendMoneyToPhoneManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'top_up_to_account_manually':
        return (
          <Panel_B06_SendMoneyToAccountManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'top_up_to_iban_manually':
        return (
          <Panel_B07_SendMoneyToIBANManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'top_up_to_customer_id_manually':
        return (
          <Panel_B07_SendMoneyToCustomerIDManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'top_up_to_cpf_cnpj_manually':
        return (
          <Panel_B07a_SendMoneyToCpfManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'top_up_to_email_manually':
        return (
          <Panel_B07b_SendMoneyToEmailManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'top_up_to_evp_manually':
        return (
          <Panel_B07c_SendMoneyToEvpManually
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'top_up_select_operator':
        return (
          <Panel_H08_TopUpSelectOperator
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'top_up_select_package':
        return (
          <Panel_H08_TopUpSelectPackage
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'top_up_change_paying_account':
        return (
          <Panel_B08_SendMoneyPayingAccount
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
            panelHeadline={select_package_title}
          />
        );
      case 'top_up_reference':
        return (
          <Panel_B09_SendMoneyReference
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'top_up_confirmation':
        return (
          <Panel_B10_SendMoneyConfirmation
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );
      case 'top_up_success':
        return (
          <Panel_B12_SendMoneySuccess
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            simPlatform={simPlatform}
            language={language}
          />
        );
      case 'link_out':
        return (
          <Panel_I01_LinkOut
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            onGotoEdit={() => {
              onGotoEdit();
            }}
            language={language}
          />
        );

      case 'theme_colors':
        return (
          <Panel_X01_themeColors
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );
      case 'theme_radius':
        return (
          <Panel_X01_themeRadius
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );
      case 'theme_fonts':
        return (
          <Panel_X02_themeFonts
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            globJSON={globJSON}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
          />
        );

      case 'keyboard_language':
        return (
          <Panel_Y01_keyboardLanguage
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            globJSON={globJSON}
            selectedScreen={index}
            language={language}
          />
        );

      case 'promotion':
        return (
          <Panel_Y02_keyboardPromotion
            onStepPressed={(i, scr) => {
              handleStepPressed(i, scr);
            }}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            globJSON={globJSON}
            selectedScreen={index}
            language={language}
          />
        );
      case 'send_form':
        return (
          <Panel_Z01_send_form
            globJSON={globJSON}
            selectedUser={selectedUser}
            loggedInUserItem={loggedInUserItem}
            selectedScreen={index}
            language={language}
            startExportingAllFiles={startExportingAllFiles}
            simPlatform={simPlatform}
          />
        );
      case 'development_configurations':
        return (
          <Panel_Z02_development_configurations />
        );

      default:
        console.log(`screen_name: ${globJSON.screens[index].screen_name}`);
        return null;
    }
  };

  return (
    <View style={myStyles.controlPanel}>
      <TopMenuServices
        globJSON={globJSON}
        onServiceTabSelected={(selection) => {
          handlePressOnServicesTab(selection);
        }}
        selectedServiceTab={calcSelectedServiceTab()}
        language={language}
        showTopMenuServices={globJSON.screens[selectedScreen].category === services_category}
      />
      <ScrollView
        ref={ref_scroll_view}
        horizontal
        pagingEnabled
        onScroll={(evt) => onScroll(evt)}
        showsHorizontalScrollIndicator={false}
        scrollEnabled
      >
        {renderControlPanelAllViews()}
      </ScrollView>

      {popupChangeOrderScreen === 'send_money_change_order' && (
        <View style={myStyles.controlPanelPopup}>
          <Panel_B13_FlowChangeOrder
            globJSON={globJSON}
            selectedScreen={selectedScreen}
            onConfigChanged={(didChange, subCategoryId) => {
              onSendMoneyOrderScreenReturning(didChange, subCategoryId);
            }}
            nowShowing={selectedScreen}
            language={language}
          />
        </View>
      )}

      {popupChangeOrderScreen === '' && (
        <View style={myStyles.controlPanelBottomBar}>
          <TouchableOpacity
            style={myStyles.btnBack}
            onPress={() => {
              onBackPressed();
            }}
          >
            <Text
              style={selectedScreen > 0 ? myStyles.bottomLabel : myStyles.bottomLabelGrey}
            >
              {LocStr(back_str, language)}
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={[
              myStyles.btnNext,
              { opacity: isSendDisabled ? 0.5 : 1.0 },
            ]}
            disabled={isSendDisabled}
            onPress={() => {
              onNextPressed();
            }}
          >
            <Text style={myStyles.bottomLabel}>
              {LocStr(Next_str, language)}
            </Text>
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
};

export default ControlPanelViewer;
